import PropTypes from 'prop-types';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * Description Block (CF-013 King Difference). Standalone in mainRegionCollection.
 * Figma 3132-5087 (desktop), 3132-6560 (mobile): subHeading = eyebrow, heading = feature heading, descriptionContent = body.
 * Block has its own padding/max-width (no Container required).
 */
export const DescriptionBlock = ({component, isComplete = true, isFetching = false, ...props}) => {
  const styles = useMultiStyleConfig('contentful/description-block', {
    component,
    isComplete,
    isFetching,
  });

  const {title, heading, subHeading, descriptionContent} = component ?? {};
  const hasContent = Boolean(subHeading || heading || descriptionContent);

  if (!hasContent) {
    return null;
  }

  return (
    <Box {...styles.container} {...props}>
      {(subHeading || heading) && (
        <Box {...styles.contentGroup}>
          {subHeading && (
            <Text {...styles.eyebrow} as="p">
              {subHeading}
            </Text>
          )}
          {heading && (
            <Text {...styles.heading} as="h2">
              {heading}
            </Text>
          )}
        </Box>
      )}
      {descriptionContent && (
        <Text {...styles.body} as="p">
          {descriptionContent}
        </Text>
      )}
    </Box>
  );
};

DescriptionBlock.displayName = 'DescriptionBlock';
DescriptionBlock.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
